import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, DialogTitle, DialogContent, DialogActions } from '@material-ui/core';
import { SmaMonitoringPlanForm } from 'src/scenes/Project/scenes/MonitoringPlans/components';

import { DialogButton } from 'src/components';
import { useFetchStatus } from 'src/hooks';


const SmaMonitoringPlanEditDialog = props => {

  const { actions, options, monitoringPlan } = props;
  const { sitesOptions } = options;

  const { id, name, sitesIds: [ siteId ], sitesNames: [ siteName ] } = monitoringPlan;

  const prevSiteSelection = siteId;

  const siteSelection = siteId ? { label: siteName, value: String(siteId) } : null;

  const [ monitoringPlanName, setMonitoringPlanName ] = useState(name || '');
  const [ site, setSite ] = useState(siteSelection);

  const { fetchStatus, errorMessage, hasBadData, hasError, handleConfirm } = useFetchStatus({
    confirmFn: () => actions.editMonitoringPlan({
      id,
      name: monitoringPlanName,
      siteId: site?.value ? Number(site.value) : undefined,
      siteName: site?.label,
      prevSiteSelection,
    }),
    validationFn: () => hasName,
    closeFn: actions.closeDialog,
  });

  const handleSiteChange = (_, selectedSite) => setSite(selectedSite);
  const handleMonitoringPlanName = value => setMonitoringPlanName(value);

  const hasName = Boolean(monitoringPlanName.trim().length);

  return (
    <>
      <DialogTitle id="form-dialog-title">Editar plan de monitoreo</DialogTitle>
      <DialogContent>
        <SmaMonitoringPlanForm
          options={{ sitesOptions }}
          validations={{ hasBadData, hasError, hasName, errorMessage }}
          actions={{ handleSiteChange, handleMonitoringPlanName }}
          data={{ monitoringPlanName, site }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={actions.closeDialog} color="secondary">Cancelar</Button>
        <DialogButton fetchStatus={fetchStatus} onClick={handleConfirm} color="primary">Editar</DialogButton>
      </DialogActions>
    </>
  );
};

SmaMonitoringPlanEditDialog.propTypes = {
  actions: PropTypes.shape({
    editMonitoringPlan: PropTypes.func.isRequired,
    closeDialog: PropTypes.func.isRequired,
  }).isRequired,
  monitoringPlan: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    sitesIds: PropTypes.arrayOf(PropTypes.number),
    sitesNames: PropTypes.arrayOf(PropTypes.string),
  }),
  options: PropTypes.shape({
    sitesOptions: PropTypes.arrayOf(PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })),
  }),
};


export {
  SmaMonitoringPlanEditDialog,
};
